<template>
  <main>
    <div class="pt-0 pr-1 pb-4 pl-1 h6 open-sans line-height-golden">
      upload video til din profil (Max 60 meg)
    </div>
    <div class="text-center">
    <b-row>
      <b-col lg="6" md="6" sm="12" v-for="video in project.videos" :key="video.id">
      <!-- notifications in general -->
        <b-card  img-alt="Profil" img-top bg-variant="light" class="border-0"  data-download="true">
          <b-card-body class="p-0 border-0">
            <div class="d-flex justify-content-between">
              <b-embed
                      type="iframe"
                      aspect="16by9"
                      :src="video.VideoUrl"
                      allowfullscreen
              ></b-embed>
              <div>

              </div>
            </div>
            <div class="container text-center">
            <b-button @click="delete_video(video.id)"  variant="outline-dark" class="border-0">
              <i class="el-icon-delete" aria-hidden="true" style="font-size:20px;"></i>
            </b-button>
            </div>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    </div>
    <dropzone id="myVueDropzone" :options="dropzoneOptions" v-on:vdropzone-success="showSuccess" v-on:vdropzone-sending="sendingEvent"></dropzone>
  </main>
</template>
<script>
import Dropzone from 'vue2-dropzone'
export default {
  name: 'projectvideo',
  props: ['project'],
  components: {
    Dropzone
  },
  data: function () {
    return {
      dropzoneOptions: {
        paramName: 'file',
        url: this.$http.options.root,
        thumbnailWidth: 150,
        maxFilesize: 62,
        createImageThumbnails: true,
        addRemoveLinks: true,
        acceptedFiles: '.mp4,.mov,.avi,.mpeg4,.flv,.3gpp',
        renameFile: true,
        dictDefaultMessage: '<i class="el-icon-video-camera"></i>  Træk filerne hertil eller klik for at vælge filer'
      },
      show: false,
      label: 'Loading...',
      overlay: 1,
      salesPerson: '',
      haaId: ''
    }
  },
  computed: {
    dropzoneSettings () {
      let defaultValues = {
        thumbnailWidth: 200,
        thumbnailHeight: 200
      }
      Object.keys(this.options).forEach(function (key) {
        defaultValues[key] = this.options[key]
      }, this)
      if (this.awss3 !== null) {
        defaultValues['autoProcessQueue'] = false
        this.isS3 = true
        if (this.options.autoProcessQueue !== undefined) {
          this.wasQueueAutoProcess = this.options.autoProcessQueue
        }
      }
      return defaultValues
    }
  },
  methods: {
    'showSuccess': function (file) {
      this.$emit('Reload')
    },
    change_position (imageId, position) {
      this.$emit('moveImage', imageId, position)
    },
    delete_video (videoId) {
      this.$emit('delete_video', videoId, this.project.projectid)
    },
    edit_image (FileLocation, imageId) {
      this.$emit('edit_image', FileLocation, imageId)
    },
    sendingEvent (file, xhr, formData) {
      this.salesPerson = localStorage.getItem('id_token_portal')
      this.haaId = localStorage.getItem('haaid')
      formData.append('salesPerson', this.salesPerson)
      formData.append('levid', this.haaId)
      formData.append('projectid', this.project.projectid)
      formData.append('operation', 'uploadVideoProject')
    }
  }
}
</script>



// WEBPACK FOOTER //
// projectvideo.vue?67ef41f3